module.exports = __webpack_public_path__ + "img/trash.b96fec04.svg";